import { getUniqueValues } from '../utils/helper';
import { Entity } from './types';

// Helper function to split cell value
const splitCellValue = (cell: Entity): [string, string] => {
  const bits = cell.value.split('-');
  return [bits[0], bits[1]];
};

// Helper function to split cell label
const splitCellLabel = (cell: Entity): [string, string] => {
  const splitMarker = ' in ';
  const itemGroupEnd = cell.label.lastIndexOf(splitMarker);
  const itemGroup = cell.label.substring(0, itemGroupEnd);
  const country = cell.label.substring(itemGroupEnd + splitMarker.length);
  return [country.trim(), itemGroup.trim()];
};

// Get distinct list of selected country codes
const getDistinctCountries = (cells: Entity[]): string[] => {
  const countries = cells.map(cell => splitCellValue(cell)[0]);
  return getUniqueValues(countries);
};

// Get distinct list of selected item group codes
const getDistinctItemGroups = (cells: Entity[]): string[] => {
  const itemGroups = cells.map(cell => splitCellValue(cell)[1]);
  return getUniqueValues(itemGroups);
};

const getCountriesText = (countries: string[]) => {
  if (countries.length === 1) {
    return countries[0];
  }

  if (countries.length <= 6) {
    return `${countries.slice(0, -1).join(', ')} & ${countries[countries.length - 1]}`;
  }

  return `${countries.length} countries`;
};

// Create a single label describing the selected cells
export const makeLabel = (cells: Entity[]): string => {
  if (cells.length === 1) {
    return cells[0].label;
  }

  const itemGroups = getDistinctItemGroups(cells);
  const countries = getDistinctCountries(cells);
  const itemGroupLabelsSet = new Set<string>();

  cells.forEach(cell => {
    const [, itemGroup] = splitCellLabel(cell);
    itemGroupLabelsSet.add(itemGroup);
  });

  const itemGroupLabels = Array.from(itemGroupLabelsSet);

  const itemGroupsText = itemGroups.length === 1 ? itemGroupLabels[0] : `${itemGroups.length} product groups`;
  const countriesText = getCountriesText(countries);

  return `${itemGroupsText} in ${countriesText}`;
};
